export const toggleFavoriteGameById = (gameId, tableId) => {
  return {
    type: 'TOGGLE_FAVORITE_GAME',
    payload: {
      gameId,
      tableId,
    },
  };
};
